import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRetoolMenuIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 16,
	viewBox: "0 0 15 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("mask", {
			id: "path-1-inside-1_3005_4480",
			fill: "white",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 7.5,
				height: 3.76471,
				rx: 1
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 7.5,
			height: 3.76471,
			rx: 1,
			stroke: "#6B6F80",
			strokeWidth: 2.4,
			mask: "url(#path-1-inside-1_3005_4480)"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "path-2-inside-2_3005_4480",
			fill: "white",
			children: /* @__PURE__ */ _jsx("rect", {
				x: 7.5,
				y: 12.2354,
				width: 7.5,
				height: 3.76471,
				rx: 1
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 7.5,
			y: 12.2354,
			width: 7.5,
			height: 3.76471,
			rx: 1,
			stroke: "#6B6F80",
			strokeWidth: 2.4,
			mask: "url(#path-2-inside-2_3005_4480)"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "path-3-inside-3_3005_4480",
			fill: "white",
			children: /* @__PURE__ */ _jsx("rect", {
				y: 4.70605,
				width: 15,
				height: 6.58824,
				rx: 1
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 4.70605,
			width: 15,
			height: 6.58824,
			rx: 1,
			stroke: "#6B6F80",
			strokeWidth: 2.4,
			mask: "url(#path-3-inside-3_3005_4480)"
		})
	]
});
export default SvgRetoolMenuIcon;
